import { useCollectionStore } from "@/stores/models/resourceCenter";

export default async function collectionExists({ to }) {
    let exists = false;
    let cId = to.params.collectionId;
    if (cId) {
        try {
            const collectionStore = useCollectionStore();
            let existing = collectionStore.item(cId);
            if (!existing) {
                await collectionStore.fetchItem({
                    key: "VIEW_COLLECTION",
                    query: { id: cId }
                });
            }

            exists = true;
        } catch (err) {
            exists = false;
        }
    }

    if (!exists) {
        return {
            name: "Not Found"
        };
    }
}
